import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { TicketType } from '../../../models';
import { InputNumberComponent } from '../input-number/input-number.component';

export interface Ticket {
  ticketType: string;
  numberOfTickets: number;
}

/**
 * This map is used to translate the type of the ticket into a human-readable string.
 */
export const ActivityTypeTranslationMap: Record<string, string> = {
    full: 'full',
    reduced: 'reduced',
    free: 'free',
};

@Component({
  selector: 'input-ticket-list',
  standalone: true,
  templateUrl: './input-ticket-list.component.html',
  styleUrl: './input-ticket-list.component.css',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
    InputNumberComponent,
  ]
})
export class InputTicketListComponent {
  ticketTypes: TicketType[] = ["full", "reduced", "free"];
  @Input() tickets: Ticket[] = [];
  @Output() ticketsChange = new EventEmitter<Ticket[]>();

  ticketForm = new FormGroup({
    ticketType: new FormControl('', Validators.required),
    numberOfTickets: new FormControl(1, [Validators.required, Validators.min(1)])
  });

  displayedColumns: string[] = ['ticketType', 'numberOfTickets', 'actions'];

  addTicket() {
    if (this.ticketForm.valid) {
      const newTicket: Ticket = {
        ticketType: this.ticketForm.value.ticketType!,
        numberOfTickets: this.ticketForm.value.numberOfTickets!
      };
      const existingTicket = this.tickets.find(t => t.ticketType === newTicket.ticketType);
      if (existingTicket) {
        existingTicket.numberOfTickets += newTicket.numberOfTickets!;
        this.ticketsChange.emit(this.tickets);
      } else {
        this.tickets = [...this.tickets, newTicket];
        this.ticketsChange.emit(this.tickets);
      }
      this.ticketForm.reset({ ticketType: '', numberOfTickets: 1 });
    }
  }

  deleteTicket(ticketToDelete: Ticket) {
    this.tickets = this.tickets.filter(t => t !== ticketToDelete);
    this.ticketsChange.emit(this.tickets);
  }


  getTicketLabel(ticketType: TicketType){
    return ActivityTypeTranslationMap[ticketType];
  }
}